const Footer = () => (
  <div className="h-[50px] w-full bg-blue-900 sm:flex items-center justify-end py-1 text-white text-[12px] sm:text-sm px-8">
    <div>
      Copyright <i className="fa-regular fa-copyright"></i>{" "}
      {new Date().getFullYear()} Excelsoft Technology Pvt Ltd.
    </div>
  </div>
);

export default Footer;
